import { AuthInfo } from "@modelcontextprotocol/sdk/server/auth/types.js";
import {
  InvalidTokenError,
  ServerError,
} from "@modelcontextprotocol/sdk/server/auth/errors.js";
import { internalRequest } from "../api/api.js";

interface ExchangeResponse {
  active: boolean;
  scope?: string | string[];
  client_id?: string;
  exp?: number;
  extra: {
    features: Record<string, unknown>;
    jwt: string;
    user_id: number;
    team_id: number;
    access_restricted_reason?: string;
  };
}

function parseScopes(scope?: string | string[]): string[] {
  if (!scope) {
    return [];
  }
  if (Array.isArray(scope)) {
    return scope.filter((item): item is string => typeof item === "string");
  }
  return scope
    .split(" ")
    .map((item) => item.trim())
    .filter(Boolean);
}

export async function verifyAccessToken(token: string): Promise<AuthInfo> {
  const exchange = await internalRequest<ExchangeResponse>(
    "/mcp/exchange_oauth_token",
    "POST",
    {
      access_token: token,
    },
  );

  if (!exchange.active) {
    throw new InvalidTokenError("Token is inactive");
  }

  if (typeof exchange.exp !== "number") {
    throw new InvalidTokenError("Token has no expiration time");
  }

  if (exchange.exp < Date.now() / 1000) {
    throw new InvalidTokenError("Token has expired");
  }

  return {
    token: exchange.extra.jwt,
    clientId: exchange.client_id ?? "unknown-client",
    scopes: parseScopes(exchange.scope),
    expiresAt: exchange.exp,
    extra: exchange.extra,
  };
}
